import React, { type ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'large' | 'full'; // 모달 크기 옵션 추가
  className?: string; // 추가적인 클래스를 적용하기 위한 prop
  actions?: ReactNode; // 모달 하단 액션 버튼
}

const sizeClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
  large: 'max-w-6xl',
  full: 'max-w-7xl w-[95vw]', // 실제로 큰 크기 적용
};

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, size = 'lg', className, actions }) => {
  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-50 flex justify-center items-center p-4 ${className}`}>
      <div className={`${sizeClasses[size]} bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full ${size === 'full' ? 'max-h-[95vh]' : 'max-h-full'} flex flex-col`}>
        {/* 헤더 부분 스타일 수정 */}
        <div className="flex justify-between items-center px-4 py-3 bg-[#4f772d] dark:bg-gray-700 rounded-t-lg">
          <h3 className="text-2xl font-medium text-white dark:text-gray-200">{title}</h3>
          <button 
            onClick={onClose} 
            className="p-1 text-green-100 rounded-full hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/50"
            aria-label="Close modal"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>
        
        {/* 본문 (스크롤 가능하도록 수정) */}
        <div className="p-6 overflow-y-auto dark:text-gray-200">
          {children}
        </div>
        
        {/* 액션 버튼 영역 */}
        {actions && (
          <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 rounded-b-lg border-t border-gray-200 dark:border-gray-600">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};
